module.exports = __webpack_public_path__ + "assets/img/promiseImg (2).124b5a11.png";